import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  userDetail,
  userUpdate,
  userSelectUser,
  selectedTeamLead,
  selectedMentor,
  selectedCoach,
  searchUser,
  userDetailBroker,
  getLicensedAs,
  fetchTimezoneArray,
  userUpdateClear,
  UserRoleRequestStatus,
  UserRoleRequestStatusClear,
  fetchTimezoneAbbr,
  getProvinceMasterData,
  getProvinceMasterDataClear,
  userDetailBrokerForOther,
} from "../../redux/user/actions";
import { clickStreamUser, SessionKeys } from "../../utils/AppUtils";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import ConfirmModal from "../modal/ConfirmModal";
import _ from "lodash";
import Loader from "../Loader/Loader";
import CONFIG from "../../utils/config";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import { getShowLoader } from "../../redux/home/actions";

const ProfilEdit = (props) => {
  const dispatch = useDispatch();
  const userRole = useSelector((state) => state.user.role);
  const auth = useSelector((state) => state.auth.auth);
  const authBroker = useSelector((state) => state.auth.authBroker);
  // const userDetailRes = useSelector(state => state.user.user)
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const userDetailResForOther = useSelector((state) => state.user.userBrokerForOther);
  const licensedAsRes = useSelector((state) => state.user.licensedAsRes);
  const userUpdateRes = useSelector((state) => state.user.userUpdateRes);
  const searchUserRes = useSelector((state) => state.user.searchUserRes);
  const provinceMaster = useSelector((state) => state.user.provinceMaster);
  // const teamLead = useSelector(state => state.user.selectedTeamLead)
  // const mentor = useSelector(state => state.user.selectedMentor)
  // const coach = useSelector(state => state.user.selectedCoach)
  const [isHost, setIsHost] = useState(
    userRole === "instructor" || userRole === "host"
  );
  const [isGuest, setIsGuest] = useState(false);
  const [teamLead, setTeamLead] = useState("");
  const [mentor, setMentor] = useState("");
  const [coach, setCoach] = useState("");
  const timezoneArray = useSelector((state) => state.user.timezoneMaster);
  const usersOfRoleAcceptanceStatus = useSelector(
    (state) => state.user.UserRoleRequestStatus
  );
  const [teamLeadInput, setTeamLeadInput] = useState("");
  const [mentorInput, setMentorInput] = useState("");
  const [coachInput, setCoachInput] = useState("");
  const [degn, setDegn] = useState("");
  const [timezone, setTimezone] = useState("");
  const [users, setUsers] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [isEdit, setIsEdit] = useState(true);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [isTeamLeadError, setIsTeamLeadError] = useState("");
  const [isMentorError, setIsMentorError] = useState("");
  const [isCoachError, setIsCoachError] = useState("");
  const [isTimeZoneError, setIsTimezoneError] = useState("");
  const [licensedAs, setLicensedAs] = useState([]);
  const [timezoneList, setTimezoneList] = useState([]);
  const [currentRole, setCurrentRole] = useState(0);
  const [selectedCoachStatus, setSelectedCoachStatus] = useState("");
  const [selectedMentorStatus, setSelectedMentorStatus] = useState("");
  const [selectedTeamLeadStatus, setSelectedTeamLeadStatus] = useState("");

  const [selectedCoachName, setSelectedCoachName] = useState("");
  const [selectedMentorName, setSelectedMentorName] = useState("");
  const [selectedTeamLeadName, setSelectedTeamLeadName] = useState("");

  const [requestedCoachId, setRequestedCoachId] = useState("");
  const [requestedMentorId, setRequestedMentorId] = useState("");
  const [requestedTeamLeadId, setRequestedTeamLeadId] = useState("");

  const [rejectReasonCoach, setRejectReasonCoach] = useState("");
  const [rejectReasonMentor, setRejectReasonMentor] = useState("");
  const [rejectReasonTeamLead, setRejectReasonTeamLead] = useState("");

  const [userRoleAccessStatus, setUserRoleAccessStatus] = useState([]);
  const [recoData, setRecoData] = useState("");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName ] = useState("");
  const [city, setCity] = useState("");
  const [province, setProvince] = useState("");
  const [provinceList, setProvinceList] = useState([]);


  const [isLoading, setIsLoading] = useState();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const user_id = params.get("user_id");
  const isOther =
    localStorage.getItem(SessionKeys.USER_ID) === user_id ? "0" : "1";
  //    params.get("isOther");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    dispatch(getProvinceMasterData({
      'module': 'getProvinceMaster',
      postData: {}
    }))
  }, [dispatch])
  useEffect(() => {
    if (!_.isEmpty(provinceMaster) ) {
      if (provinceMaster.status === 'success') {
        let tempList = [{id:"",name:"Select Province"}]
        const plist = _.cloneDeep(provinceMaster.payload.payload)
        let finalList = [...tempList,...plist];
        if (!_.isEmpty(finalList)) {
          setProvinceList(finalList)
        }
      }
      dispatch(getProvinceMasterDataClear())
    }
  }, [provinceMaster])
  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      console.log("authBroker: ", authBroker, auth);
      if (!_.isEmpty(authBroker.payload.user.role)) {
        setIsGuest(authBroker.payload.user.role.includes("guest"));
      }
    }
  }, [authBroker]);

  useEffect(() => {

    let userDetailResLocal = isOther === "1"?userDetailResForOther:userDetailRes;

    if (
      !_.isEmpty(userDetailResLocal) &&
      !_.isEmpty(timezoneArray) &&
      !_.isEmpty(licensedAsRes)
    ) {
      setIsLoading(false);
      dispatch(getShowLoader(false));
    }
  }, [userDetailRes,userDetailResForOther, timezoneArray, licensedAsRes]);

  const getUserDetail = () => {
    dispatch(getShowLoader(true));
    if (isOther === "1") {
      setIsEdit(false);
      dispatch(
        userDetailBrokerForOther({
          module: "getUserDetailBrokerForOther",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            rea_user_id: user_id,
          },
        })
      );
    } else {
      dispatch(
        userDetailBroker({
          module: "getOrderDetailBroker",
          apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        })
      );
    }
  };

  useEffect(() => {
    setIsLoading(true);
    getUserDetail();

    dispatch(
      fetchTimezoneArray({
        module: "getTimezone",
        postData: {},
      })
    );

    dispatch(
      getLicensedAs({
        module: "getLicensedAs",
        postData: {},
      })
    );
  }, [dispatch,user_id]);

  useEffect(() => {
    // console.log('licensedAsRes: ', licensedAsRes)
    if (licensedAsRes?.status === "success") {
      setLicensedAs(licensedAsRes.payload.payload);
    }
  }, [licensedAsRes]);

  useEffect(() => {
    let userDetailResLocal = isOther === "1"?userDetailResForOther:userDetailRes;
    if (!_.isEmpty(licensedAs) && !_.isEmpty(userDetailResLocal)) {
      licensedAs.map((cat) => {
        if (userDetailResLocal?.payload?.payload?.degn === cat.designation) {
          setRecoData(cat.designation);
        }
      });
    }
  }, [licensedAs, userDetailRes,userDetailResForOther]);

  useEffect(() => {
    if (!_.isEmpty(timezoneArray)) {
      if (timezoneArray.status === "success") {
        setTimezoneList(timezoneArray.payload.payload);
      } else {
        setTimezoneList([]);
      }
    }
  }, [timezoneArray]);

  useEffect(() => {
    if (!confirmModal) {
      setConfirmModal(false);
    }
  }, [confirmModal]);

  useEffect(() => {
    let userDetailResLocal = isOther === "1"?userDetailResForOther:userDetailRes;
    if (!_.isEmpty(userDetailResLocal)) {
      if (userDetailResLocal.status === "success") {
        setFirstName(userDetailResLocal?.payload?.payload?.firstname)
        setLastName(userDetailResLocal?.payload?.payload?.lastname)
        setCity(userDetailResLocal?.payload?.payload?.office_city)

        setTeamLead(userDetailResLocal?.payload?.payload?.team_lead_id);
        setMentor(userDetailResLocal?.payload?.payload?.mentor_id);
        setCoach(userDetailResLocal?.payload?.payload?.coach_id);        
        setTeamLeadInput(
          userDetailResLocal?.payload?.payload?.team_lead === " "
            ? ""
            : userDetailResLocal?.payload?.payload?.team_lead
        );
        setMentorInput(
          userDetailResLocal?.payload?.payload?.mentor === " "
            ? ""
            : userDetailResLocal?.payload?.payload?.mentor
        );
        setCoachInput(
          userDetailResLocal?.payload?.payload?.coach === " "
            ? ""
            : userDetailResLocal?.payload?.payload?.coach
        );
        setDegn(
          userDetailResLocal?.payload?.payload?.degn === " "
            ? ""
            : userDetailResLocal?.payload?.payload?.degn
        );
        setTimezone(
          userDetailResLocal.payload?.payload?.timezone === ""
            ? ""
            : userDetailResLocal?.payload?.payload?.timezone
        );
        getRoleReqStatus();

        if (!_.isEmpty(userDetailResLocal?.payload?.payload)) {
          dispatch(fetchTimezoneAbbr(userDetailResLocal.payload.payload.timezone));
        }
      }
      // setIsLoading(false)
    }
  }, [userDetailRes,userDetailResForOther]);

  useEffect(() => {
    if (!_.isEmpty(userUpdateRes)) {
      if (userUpdateRes?.status === "success") {
        getUserDetail();
        setShowModalMsg("Profile updated successfully.");
      } else {
        setShowModalMsg("Error updating profile.");
      }
      setConfirmModal(true);
      setIsConfirm(false);
      dispatch(userUpdateClear());
      setIsLoading(false);
    }
  }, [userUpdateRes]);

  useEffect(() => {
    // console.log('userDetailRes111searchUserRes: ', searchUserRes)
    if (searchUserRes?.status === "success") {
      const persons = searchUserRes?.payload.searchData;
      if (persons !== undefined && persons?.length > 0) {
        var tempArray = [];
        for (let index = 0; index < persons?.length; index++) {
          const element = persons[index];
          // console.log('element: ', element)
          tempArray.push({
            label:
              element.first_name +
              " " +
              element.last_name +
              " " +
              element.username,
            value: element.ID,
            showValue: element.first_name + " " + element.last_name,
          });
        }
        // console.log('searchDataAfterForLoop: ', tempArray)
        setUsers(tempArray);
      } else {
        setUsers([]);
      }
    } else {
      setUsers([]);
    }
  }, [searchUserRes]);

  const userProfileUpdate = () => {
    if (_.isString(coach) && coach?.length > 0) {
      setIsCoachError("Please select correct input for Coach");
      return;
    }
    if (_.isString(mentor) && mentor?.length > 0) {
      setIsMentorError("Please select correct input for Mentor");
      return;
    }
    if (_.isString(teamLead) && teamLead?.length > 0) {
      setIsTeamLeadError("Please select correct input for Team Lead");
      return;
    }

    if (_.isEmpty(timezone)) {
      setIsTimezoneError("Please select timezone from list");
      return;
    }

    setIsEdit(false);
    setIsLoading(true);

    const params = {
      team_lead: teamLead === null ? "" : teamLead,
      mentor: mentor === null ? "" : mentor,
      coach: coach === null ? "" : coach,
      licensedAs: degn === null ? "" : degn,
      timezone: timezone === null ? "" : timezone,
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      firstname: firstName,
      lastname: lastName,
      office_city: city,
      office_province: province
    };

    dispatch(userUpdate(params));
  };

  const handleChange = (event) => {
    // console.log(event.target.value);
  };

  const getSearchResult = (searchInput, role) => {
    var reqObj = {
      broker_id: localStorage.getItem(SessionKeys.BROKER_ID),
      search: searchInput,
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      user_role: role,
    };

    dispatch(searchUser(reqObj));
  };

  const getOptions = (query) => {
    // console.log(query)
  };

  //User Role Request Status
  useEffect(() => {
    if (usersOfRoleAcceptanceStatus?.status === "success") {
      // console.log('inputs ', coachInput + ', ' + mentorInput + teamLeadInput + ', ')
      if (Array.isArray(usersOfRoleAcceptanceStatus?.payload?.payload)) {
        let roleArr = usersOfRoleAcceptanceStatus?.payload?.payload;
        if (coachInput === "") {
          setSelectedCoachStatus(
            roleArr.filter((i) => i.role_name === "coach")[0]?.status
          );
          setSelectedCoachName(
            roleArr.filter((i) => i.role_name === "coach")[0]?.user_name
          );
          setRequestedCoachId(
            Number(roleArr.filter((i) => i.role_name === "coach")[0]?.role_id)
          );
          setRejectReasonCoach(
            roleArr.filter((i) => i.role_name === "coach")[0]?.reason
          );
        } else {
          setSelectedCoachStatus("Accepted");
          setSelectedCoachName(coachInput);
        }

        if (mentorInput === "") {
          setSelectedMentorStatus(
            roleArr.filter((i) => i.role_name === "mentor")[0]?.status
          );
          setSelectedMentorName(
            roleArr.filter((i) => i.role_name === "mentor")[0]?.user_name
          );
          setRequestedMentorId(
            Number(roleArr.filter((i) => i.role_name === "mentor")[0]?.role_id)
          );
          setRejectReasonMentor(
            roleArr.filter((i) => i.role_name === "mentor")[0]?.reason
          );
        } else {
          setSelectedMentorStatus("Accepted");
          setSelectedMentorName(mentorInput);
        }

        if (teamLeadInput === "") {
          setSelectedTeamLeadStatus(
            roleArr.filter((i) => i.role_name === "team_lead")[0]?.status
          );
          setSelectedTeamLeadName(
            roleArr.filter((i) => i.role_name === "team_lead")[0]?.user_name
          );
          setRequestedTeamLeadId(
            Number(
              roleArr.filter((i) => i.role_name === "team_lead")[0]?.role_id
            )
          );
          setRejectReasonTeamLead(
            roleArr.filter((i) => i.role_name === "team_lead")[0]?.reason
          );
        } else {
          setSelectedTeamLeadStatus("Accepted");
          setSelectedTeamLeadName(teamLeadInput);
        }
      }
    }
  }, [usersOfRoleAcceptanceStatus]);
  // useEffect(() => {
  //   getRoleReqStatus();
  // }, [])

  const getRoleReqStatus = () => {
    dispatch(
      UserRoleRequestStatus({
        module: "userRoleRequestStatus",
        postData: { token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) },
      })
    );
  };

  return (
    <>
      {/* <Loader start={isLoading} /> */}
      <section className="profile-info">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              {isLoading ? (
                <ShimmerScreen case={"rect"} height={"30px"} width={"25%"} />
              ) : (
                <h4>Personal Details</h4>
              )}
            </div>
          </div>
          <div className="row  mt-5 edit_profile_input">
            <div className="col-md-4 required">
              {isLoading ? (
                <div className="input-text position-relative disable_field">
                  <ShimmerScreen case={"rect"} width={"60%"} height={"12px"} />
                  <span className="input__field02" style={{ marginTop: "5px" }}>
                    <ShimmerScreen
                      case={"rect"}
                      width={"100%"}
                      height={"25px"}
                    />
                  </span>
                </div>
              ) : (
                <div className="input-text position-relative disable_field">
                  <label htmlFor="first_name" className="input__label">
                    { "First Name" }
                  </label>
                  <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    className="input__field02"
                    placeholder=" "
                    value={firstName}
                    readOnly={userRole !== "customer" ? true :isEdit ? false : true}
                    onChange={(evt) => { setFirstName(evt.target.value) }}
                  />
                </div>
              )}
            </div>
            {userRole !== "customer" && <div className="col-md-4 required">
              {isLoading ? (
                <div className="input-text position-relative disable_field">
                  <ShimmerScreen case={"rect"} width={"60%"} height={"12px"} />
                  <span className="input__field02" style={{ marginTop: "5px" }}>
                    <ShimmerScreen
                      case={"rect"}
                      width={"100%"}
                      height={"25px"}
                    />
                  </span>
                </div>
              ) : (
                <div className="input-text position-relative disable_field">
                  <label htmlFor="last_name" className="input__label">
                    Middle Name
                  </label>
                  <input
                    type="text"
                    id="last_name"
                    name="last_name"
                    className="input__field02"
                    placeholder=" "
                    value={isOther==="1"?userDetailResForOther?.payload?.payload?.middlename:userDetailRes?.payload?.payload?.middlename}
                    readOnly
                  />
                </div>
              )}
            </div>}
            {/* </div> */}
            {/* <div className="row mt-3 edit_profile_input"> */}
            { <div className="col-md-4 required">
              {isLoading ? (
                <div className="input-text position-relative disable_field">
                  <ShimmerScreen case={"rect"} width={"60%"} height={"12px"} />
                  <span className="input__field02" style={{ marginTop: "5px" }}>
                    <ShimmerScreen
                      case={"rect"}
                      width={"100%"}
                      height={"25px"}
                    />
                  </span>
                </div>
              ) : (
                <div className="input-text position-relative disable_field">
                  <label htmlFor="last_name" className="input__label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    id="last_name"
                    name="last_name"
                    className="input__field02"
                    placeholder=" "
                    value={lastName}
                    readOnly={userRole !== "customer" ? true :isEdit ? false : true}
                    onChange={(evt) => { setLastName(evt.target.value) }}
                  />
                </div>
              )}
            </div>}

            <div className="col-md-4 required">
              {isLoading ? (
                <div className="input-text position-relative disable_field">
                  <ShimmerScreen case={"rect"} width={"60%"} height={"12px"} />
                  <span className="input__field02" style={{ marginTop: "5px" }}>
                    <ShimmerScreen
                      case={"rect"}
                      width={"100%"}
                      height={"25px"}
                    />
                  </span>
                </div>
              ) : (
                <div className="input-text position-relative disable_field">
                  <label htmlFor="email" className="input__label">
                    Email Address
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    className="input__field02"
                    placeholder=" "
                    value={isOther==="1"?userDetailResForOther?.payload?.payload?.email:userDetailRes?.payload?.payload?.email}
                    readOnly
                  />
                </div>
              )}
            </div>
            {/* </div> */}
            {isHost ? (
              ""
            ) : userRole !== "customer" &&
              // <div className="row mt-3 edit_profile_input">
              !isGuest ? (
              <div className="col-md-4 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field02"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="date_join" className="input__label">
                      Date of Joining Brokerage (MM/DD/YYYY)
                    </label>
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="text"
                        id="date_join"
                        name="date_join"
                        className="input__field02"
                        placeholder=" "
                        value={isOther==="1"?userDetailResForOther?.payload?.payload?.doj:userDetailRes?.payload?.payload?.doj}
                        readOnly
                      />
                      <img
                        src="/images/edit_profile_calPG011.png"
                        width="28"
                        height="28"
                        alt="calendar"
                      />
                    </div>
                  </div>
                )}
              </div>
            ) : userRole !== "customer" &&
              authBroker.payload?.user?.config?.learning_points !== "false" ? (
              <div className="col-md-4 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field02"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="manager" className="input__label">
                      Manager
                    </label>
                    <input
                      type="text"
                      id="manager"
                      name="manager"
                      className="input__field02"
                      placeholder=" "
                      value={isOther==="1"?userDetailResForOther?.payload?.payload?.manager:userDetailRes?.payload?.payload?.manager}
                      readOnly
                    />
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
            {!isHost && userRole !== "customer" && (
              <div className="col-md-4 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field02"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-lear position-relative disable_field">
                    <label htmlFor="category" className="input__label_learning">
                      Title
                    </label>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      className="input__field02"
                      placeholder=" "
                      value={recoData}
                      readOnly
                    />
                  </div>
                )}
              </div>
            )}

            {/* <div className="row mt-3 edit_profile_input"> */}
            {!isHost && (
              <div className="col-md-4 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field02"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="city" className="input__label">
                      City
                    </label>
                    <input
                      type="text"
                      id="city"
                      name="city"
                      className="input__field02"
                      placeholder=" "
                      value={city}
                      readOnly={userRole !== "customer" ? true :isEdit ? false : true}
                      onChange={(evt) => { setCity(evt.target.value) }}
                    />
                  </div>
                )}
              </div>
            )}

            {!isHost && userRole === "customer" &&
              <div className="col-md-4">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field02"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <>
                    <div className="input-lear position-relative">
                      <label
                        htmlFor="category"
                        className="input__label_learning"
                      >
                        Province
                      </label>
                      <select
                        className="form-select input_searchfield"
                        id="category"
                        aria-label="Default select example"
                        disabled={isEdit ? false : true}
                        onChange={(ev) => {
                          if(ev.target.value==="Select Province"){
                            setProvince("");
                          }else{
                            setProvince(ev.target.value);
                          }
                        }}
                      >
                        {/* <option selected="" value="">Select Timezone</option> */}
                        {provinceList.map((cat, index) => {
                          return (
                            <option
                              value={cat.name}
                              selected={
                                isOther==="1"?userDetailResForOther?.payload?.payload?.office_province:userDetailRes?.payload?.payload?.office_province ===
                                  cat.name
                                  ? true
                                  : false
                              }
                              key={index}
                            >
                              {cat.name}{" "}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </>
                )}
              </div>
            }

            {!isHost && userRole !== "customer" && (
              <div className="col-md-4 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field02"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="province" className="input__label">
                      Province
                    </label>
                    <input
                      type="text"
                      id="province"
                      name="province"
                      className="input__field02"
                      placeholder=" "
                      value={isOther==="1"?userDetailResForOther?.payload?.payload?.office_province:userDetailRes?.payload?.payload?.office_province}
                      readOnly
                    />
                  </div>
                )}
              </div>
            )}

            {/* <div className="row mt-3 edit_profile_input"> */}
            {userRole !== "customer" && !isHost && (
              <div className="col-md-4 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field02"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="province" className="input__label">
                      {!_.isEmpty(
                        localStorage.getItem(SessionKeys.SHOW_OFFICE_NAME)
                      ) &&
                        localStorage.getItem(SessionKeys.SHOW_OFFICE_NAME) !==
                        "undefined"
                        ? localStorage.getItem(SessionKeys.SHOW_OFFICE_NAME)
                        : "Office"}
                    </label>
                    <input
                      type="text"
                      id="province"
                      name="province"
                      className="input__field02"
                      placeholder=" "
                      value={isOther==="1"?userDetailResForOther?.payload?.payload?.office_name:userDetailRes?.payload?.payload?.office_name}
                      readOnly
                    />
                  </div>
                )}
              </div>
            )}
            {
              <div className="col-md-4">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field02"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <>
                    <div className="input-lear position-relative">
                      <label
                        htmlFor="category"
                        className="input__label_learning"
                      >
                        Time zone
                      </label>
                      <select
                        className="form-select input_searchfield"
                        id="category"
                        aria-label="Default select example"
                        disabled={isEdit ? false : true}
                        onChange={(ev) => {
                          setTimezone(ev.target.value);
                        }}
                      >
                        {/* <option selected="" value="">Select Timezone</option> */}
                        {timezoneList.map((cat, index) => {
                          return (
                            <option
                              value={cat.offset}
                              selected={
                                timezone ===
                                  cat.offset
                                  ? true
                                  : false
                              }
                              key={index}
                            >
                              {cat.timezone}{" "}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <p className="error-msg">{isTimeZoneError}</p>
                  </>
                )}
              </div>
            }
            {/* </div> */}

            {!isGuest &&
              !isHost &&
              userRole !== "customer" &&
              authBroker.payload?.user?.config?.reco_license !== "false" && (
                //   <div className="row mt-3 edit_profile_input">
                <>
                  <div className="col-md-4 required">
                    {isLoading ? (
                      <div className="input-text position-relative disable_field">
                        <ShimmerScreen
                          case={"rect"}
                          width={"60%"}
                          height={"12px"}
                        />
                        <span
                          className="input__field02"
                          style={{ marginTop: "5px" }}
                        >
                          <ShimmerScreen
                            case={"rect"}
                            width={"100%"}
                            height={"25px"}
                          />
                        </span>
                      </div>
                    ) : (
                      <div className="input-text position-relative disable_field">
                        <label htmlFor="licence_date" className="input__label">
                          RECO Licence Issue Date (MM/DD/YYYY)
                        </label>
                        <div className="d-flex align-items-center gap-2">
                          <input
                            type="text"
                            id="licence_date"
                            name="licence_date"
                            className="input__field02"
                            placeholder=" "
                            value={
                              isOther==="1"?userDetailResForOther?.payload?.payload?.license_date:userDetailRes?.payload?.payload?.license_date
                            }
                            readOnly
                          />
                          <img
                            src="/images/edit_profile_calPG011.png"
                            width="28"
                            height="28"
                            alt="calendar"
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="col-md-4 required">
                    {isLoading ? (
                      <div className="input-text position-relative disable_field">
                        <ShimmerScreen
                          case={"rect"}
                          width={"60%"}
                          height={"12px"}
                        />
                        <span
                          className="input__field02"
                          style={{ marginTop: "5px" }}
                        >
                          <ShimmerScreen
                            case={"rect"}
                            width={"100%"}
                            height={"25px"}
                          />
                        </span>
                      </div>
                    ) : (
                      <div className="input-text position-relative disable_field">
                        <label htmlFor="license_num" className="input__label">
                          RECO License Number
                        </label>
                        <input
                          type="text"
                          id="license_num"
                          name="license_num"
                          className="input__field02"
                          placeholder=" "
                          value={
                            isOther==="1"?userDetailResForOther?.payload?.payload?.license_number:userDetailRes?.payload?.payload?.license_number
                          }
                          readOnly
                        />
                      </div>
                    )}
                  </div>
                </>
                //   </div>
              )}
            {!isGuest &&
              userRole !== "customer" &&
              !isHost &&
              // <div className="row mt-3 edit_profile_input">
              authBroker.payload?.user?.config?.reco_license !== "false" && (
                <div className="col-md-4 required">
                  {isLoading ? (
                    <div className="input-text position-relative disable_field">
                      <ShimmerScreen
                        case={"rect"}
                        width={"60%"}
                        height={"12px"}
                      />
                      <span
                        className="input__field02"
                        style={{ marginTop: "5px" }}
                      >
                        <ShimmerScreen
                          case={"rect"}
                          width={"100%"}
                          height={"25px"}
                        />
                      </span>
                    </div>
                  ) : (
                    <div className="input-text position-relative disable_field">
                      <label htmlFor="manager" className="input__label">
                        Broker of Record
                      </label>
                      <input
                        type="text"
                        id="manager"
                        name="manager"
                        className="input__field02"
                        placeholder=" "
                        value={
                          isOther==="1"?userDetailResForOther?.payload?.payload?.broker_of_records:userDetailRes?.payload?.payload?.broker_of_records
                        }
                        readOnly
                      />
                    </div>
                  )}
                </div>
              )}

            {!isHost &&
              userRole !== "customer" &&
              authBroker.payload?.user?.config?.learning_points !== "false" && (
                <div className="col-md-4 required">
                  {isLoading ? (
                    <div className="input-text position-relative disable_field">
                      <ShimmerScreen
                        case={"rect"}
                        width={"60%"}
                        height={"12px"}
                      />
                      <span
                        className="input__field02"
                        style={{ marginTop: "5px" }}
                      >
                        <ShimmerScreen
                          case={"rect"}
                          width={"100%"}
                          height={"25px"}
                        />
                      </span>
                    </div>
                  ) : (
                    <div className="input-text position-relative disable_field">
                      <label htmlFor="manager" className="input__label">
                        Manager
                      </label>
                      <input
                        type="text"
                        id="manager"
                        name="manager"
                        className="input__field02"
                        placeholder=" "
                        value={isOther==="1"?userDetailResForOther?.payload?.payload?.manager:userDetailRes?.payload?.payload?.manager}
                        readOnly
                      />
                    </div>
                  )}
                </div>
              )}
          </div>
          {/* </div> */}

          {!_.isEmpty(authBroker) && false ? (
            ""
          ) : (userRole === "realtor" || userRole === "manager") &&
            userRole !== "customer" ? (
            <>
              <div className="row mt-3 mb-2 edit_profile_input userdetslsd">
                <div className="col-md-12">
                  <div className="frmsep"></div>

                  {isLoading ? (
                    <ShimmerScreen
                      case={"rect"}
                      height={"30px"}
                      width={"35%"}
                    />
                  ) : (
                    <label className="role_head">
                      Additional Brokerage Support
                    </label>
                  )}
                </div>
              </div>

              <div className="row mt-3 edit_profile_input userdetslsd">
                <div className="col-md-4">
                  {isLoading ? (
                    <div
                      className="input-text position-relative"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"60%"}
                        height={"12px"}
                      />
                      <span
                        className="input__field02"
                        style={{ marginTop: "5px" }}
                      >
                        <ShimmerScreen
                          case={"rect"}
                          width={"100%"}
                          height={"25px"}
                        />
                      </span>
                    </div>
                  ) : (
                    <>
                      <div
                        className={`input-text position-relative ${isEdit ? "input__field_auto_cmplt" : ""
                          }`}
                      >
                        <Autocomplete
                          disabled={isEdit ? false : true}
                          disablePortal
                          size="small"
                          id="combo-box-demo"
                          autoComplete
                          includeInputInList
                          className={`${coachInput ? "has-value" : "has-no-value"
                            }`}
                          options={
                            coachInput !== undefined && coachInput?.length >= 2
                              ? users
                              : [
                                {
                                  label:
                                    "Type at least 3 characters to search",
                                  value: "",
                                  showValue:
                                    "Type at least 3 characters to search",
                                },
                              ]
                          }
                          sx={{ width: "100%" }}
                          onChange={(event, value) => {
                            // if (
                            //     value.value === teamLead ||
                            //     value.value === mentor ||
                            //     value.value === requestedTeamLeadId ||
                            //     value.value === requestedMentorId
                            // ) {
                            //     setIsCoachError(
                            //         "Please select different user for mentor and coach."
                            //     );
                            //     setCoach("");
                            //     setCoachInput("");
                            // } else {
                            if (_.isEmpty(value)) {
                            } else {
                              setIsCoachError("");
                              setCoach(value.value);
                              setCoachInput(value.showValue);
                            }
                            // }
                          }}
                          onInputChange={(e) => {
                            setCurrentRole(1);
                            if (e !== null) {
                              setCoachInput(e.target.value);
                              // dispatch(selectedCoach(e.target.value))
                              setCoach(e.target.value);
                              if (e.target.value?.length > 2) {
                                getSearchResult(e.target.value.trim(), "coach");
                              } else {
                                setUsers([]);
                              }
                            }
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Coach" />
                          )}
                          value={coachInput}
                        />
                      </div>

                      <div className="statusshowsec">
                        {!_.isEmpty(selectedCoachStatus) ? (
                          selectedCoachStatus?.toLowerCase() === "reject" ? (
                            <p className="d-flex align-items-baseline gap-2">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_34_20919)">
                                  <path
                                    d="M7 14C10.8658 14 14 10.8658 14 7C14 3.13417 10.8658 0 7 0C3.13417 0 0 3.13417 0 7C0 10.8658 3.13417 14 7 14Z"
                                    fill="#F57C7C"
                                  />
                                  <path
                                    d="M7 14C6.08075 14 5.1705 13.8189 4.32122 13.4672C3.47194 13.1154 2.70026 12.5998 2.05025 11.9497C1.40024 11.2997 0.884626 10.5281 0.532843 9.67878C0.18106 8.8295 0 7.91925 0 7C0 6.08075 0.18106 5.1705 0.532843 4.32122C0.884626 3.47194 1.40024 2.70026 2.05025 2.05025C2.70026 1.40024 3.47194 0.884626 4.32122 0.532843C5.1705 0.18106 6.08075 -1.36979e-08 7 0V14Z"
                                    fill="#FFCACA"
                                  />
                                  <path
                                    d="M7 0C8.93297 0 10.683 0.783512 11.9498 2.05033C13.2166 3.31702 14.0001 5.06714 14.0001 7C14.0001 8.93309 13.2166 10.683 11.9498 11.9497C10.683 13.2165 8.93297 14 7 14C5.06702 14 3.31702 13.2165 2.05033 11.9497C0.783512 10.683 0 8.93298 0 6.99989C0 5.06702 0.783512 3.31691 2.05033 2.05021C3.31702 0.783512 5.06702 0 7 0ZM9.13281 4.25754C9.28104 4.1092 9.52155 4.1092 9.66978 4.25754C9.818 4.40576 9.818 4.64616 9.66978 4.7945L7.46393 7.00046L9.66978 9.20641C9.818 9.35464 9.818 9.59504 9.66978 9.74338C9.52155 9.8916 9.28104 9.8916 9.13281 9.74338L6.92686 7.53742L4.7209 9.74349C4.57267 9.89172 4.33216 9.89172 4.18394 9.74349C4.03571 9.59515 4.03571 9.35475 4.18394 9.20653L6.39001 7.00057L4.18394 4.7945C4.03571 4.64616 4.03571 4.40576 4.18394 4.25754C4.33216 4.1092 4.57267 4.1092 4.7209 4.25754L6.92697 6.46349L9.13281 4.25754ZM11.4128 2.58717C10.2835 1.45788 8.72334 0.759473 7 0.759473C5.27666 0.759473 3.71659 1.45788 2.58729 2.58717C1.45799 3.71647 0.759473 5.27666 0.759473 6.99989C0.759473 8.72323 1.45799 10.2834 2.58717 11.4127C3.71647 12.5419 5.27655 13.2404 6.99989 13.2404C8.72323 13.2404 10.2834 12.5419 11.4127 11.4127C12.542 10.2834 13.2405 8.72323 13.2405 6.99989C13.2406 5.27666 12.5421 3.71647 11.4128 2.58717Z"
                                    fill="black"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_34_20919">
                                    <rect
                                      width="13.988"
                                      height="14"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>{" "}
                              {isOther === "0" ? (
                                <span>
                                  <b>{selectedCoachName}</b> has rejected your
                                  request.{" "}
                                  {rejectReasonCoach && (
                                    <>
                                      <b> Reason: </b> {rejectReasonCoach}
                                    </>
                                  )}
                                </span>
                              ) : (
                                <span>
                                  <b>{selectedCoachName}</b> has rejected the
                                  request.{" "}
                                  {rejectReasonCoach && (
                                    <>
                                      <b> Reason: </b> {rejectReasonCoach}
                                    </>
                                  )}
                                </span>
                              )}
                            </p>
                          ) : selectedCoachStatus?.toLowerCase() ===
                            "pending" ? (
                            <p className="d-flex align-items-baseline gap-2">
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1907_105419)">
                                  <path
                                    d="M7 14C10.8658 14 14 10.8658 14 7C14 3.13417 10.8658 0 7 0C3.13417 0 0 3.13417 0 7C0 10.8658 3.13417 14 7 14Z"
                                    fill="#FAA16F"
                                  />
                                  <path
                                    d="M7 14C6.08075 14 5.1705 13.8189 4.32122 13.4672C3.47194 13.1154 2.70026 12.5998 2.05025 11.9497C1.40024 11.2997 0.884626 10.5281 0.532843 9.67878C0.18106 8.8295 0 7.91925 0 7C0 6.08075 0.18106 5.1705 0.532843 4.32122C0.884626 3.47194 1.40024 2.70026 2.05025 2.05025C2.70026 1.40024 3.47194 0.884626 4.32122 0.532843C5.1705 0.18106 6.08075 -1.36979e-08 7 0V14Z"
                                    fill="#FFDDCA"
                                  />
                                  <path
                                    d="M5.92331 4.26033C5.92331 3.9609 6.16591 3.7183 6.46534 3.7183C6.7645 3.7183 7.0071 3.9609 7.0071 4.26033V7.55926L9.26512 8.5518C9.5386 8.67229 9.66291 8.99166 9.54243 9.26514C9.42194 9.53888 9.10257 9.66292 8.82909 9.54244L6.27465 8.41957C6.06947 8.34253 5.92331 8.14446 5.92331 7.91224V4.26033ZM0.253533 4.19449C0.23878 4.14313 0.230857 4.08876 0.230857 4.03276L0.235228 2.02718C0.235228 1.7037 0.49723 1.4417 0.820702 1.4417C1.1439 1.4417 1.40618 1.7037 1.40618 2.02718L1.40454 2.78832C1.75269 2.32524 2.15724 1.90738 2.60881 1.54443C3.06725 1.17642 3.5806 0.860327 4.14367 0.608981C5.90856 -0.178116 7.82371 -0.175931 9.4938 0.46391C11.1513 1.09883 12.569 2.36185 13.3599 4.10434C13.3752 4.13193 13.388 4.16089 13.3984 4.19094C14.1658 5.94354 14.1587 7.84093 13.5241 9.49681C12.914 11.0893 11.7245 12.46 10.0872 13.2665C10.0768 13.2725 10.0664 13.2779 10.0555 13.2834C9.71564 13.4511 9.35993 13.591 8.99711 13.7014C8.8616 13.7413 8.72063 13.7284 8.59605 13.6615C8.18352 13.4394 8.24471 12.8293 8.69249 12.693C8.93236 12.6192 9.16568 12.5326 9.3938 12.4307C9.405 12.425 9.41675 12.4198 9.4285 12.4149C9.48314 12.39 9.53751 12.3643 9.59133 12.3378C9.60581 12.3307 9.62056 12.3242 9.63559 12.3184C11.0185 11.6327 12.0239 10.4713 12.5408 9.12252C13.0853 7.70078 13.0883 6.07249 12.4203 4.57479L12.4201 4.57424C11.7518 3.07655 10.5393 1.99139 9.11923 1.44744C7.69749 0.902674 6.06947 0.899942 4.57177 1.56792C4.10456 1.77586 3.6661 2.04316 3.26723 2.36322C2.88036 2.67404 2.53422 3.03239 2.23698 3.4298L2.70416 3.4033C3.02736 3.38554 3.30411 3.63333 3.32187 3.95681C3.33963 4.28001 3.09184 4.55676 2.76836 4.57452L0.863868 4.68216C0.562799 4.69855 0.302163 4.48518 0.253533 4.19449ZM6.74647 13.9997C7.22594 14.0148 7.47565 13.4383 7.13606 13.0987C7.03852 13.0045 6.92023 12.9526 6.78472 12.9468C6.45906 12.9362 6.14324 12.8998 5.82332 12.8373C5.61787 12.7979 5.41788 12.8766 5.29358 13.0446C5.07092 13.3577 5.23976 13.794 5.61732 13.8702C5.98957 13.9439 6.3672 13.9872 6.74647 13.9997ZM3.49208 13.0648C3.81309 13.2503 4.21716 13.0627 4.27918 12.696C4.31278 12.4783 4.21525 12.2698 4.02619 12.1567C3.74561 11.9931 3.48443 11.8095 3.23417 11.6027C2.85825 11.2928 2.30091 11.6114 2.37741 12.0931C2.39954 12.2215 2.46074 12.3277 2.56018 12.4122C2.85251 12.6547 3.16418 12.873 3.49208 13.0648ZM1.06959 10.7066C1.31219 11.092 1.89384 11.0117 2.02252 10.5743C2.06377 10.4279 2.04328 10.2784 1.96324 10.1489C1.79139 9.87492 1.64359 9.58833 1.51764 9.29027C1.34826 8.88757 0.788191 8.85397 0.573453 9.23454C0.493132 9.37524 0.483296 9.54817 0.546133 9.69734C0.69257 10.0462 0.868512 10.3861 1.06959 10.7066ZM0.0180322 7.49123C0.0349708 7.727 0.204083 7.92043 0.435213 7.96961C0.780541 8.03873 1.09063 7.76853 1.06877 7.41692C1.04555 7.09263 1.04883 6.7738 1.07751 6.44978C1.09363 6.25745 1.00948 6.07659 0.850481 5.96703C0.516627 5.74164 0.0666623 5.95337 0.0286871 6.35416C-0.00559383 6.73227 -0.00915714 7.11254 0.0180322 7.49123Z"
                                    fill="black"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1907_105419">
                                    <rect
                                      width="13.988"
                                      height="14"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              {isOther === "0" ? (
                                <span>
                                  Your request is pending with{" "}
                                  <b>{selectedCoachName}</b>.
                                </span>
                              ) : (
                                <span>
                                  Request is pending with{" "}
                                  <b>{selectedCoachName}</b>.
                                </span>
                              )}
                            </p>
                          ) : selectedCoachStatus?.toLowerCase() ===
                            "accepted" ? (
                            <p className="d-flex align-items-baseline gap-2">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1907_105392)">
                                  <path
                                    d="M7.99935 14.7077C11.7041 14.7077 14.7077 11.7041 14.7077 7.99935C14.7077 4.2946 11.7041 1.29102 7.99935 1.29102C4.2946 1.29102 1.29102 4.2946 1.29102 7.99935C1.29102 11.7041 4.2946 14.7077 7.99935 14.7077Z"
                                    fill="#78EB7B"
                                  />
                                  <path
                                    d="M7.99935 14.7077C7.1184 14.7077 6.24607 14.5342 5.43218 14.197C4.61829 13.8599 3.87877 13.3658 3.25584 12.7429C2.63291 12.1199 2.13878 11.3804 1.80166 10.5665C1.46453 9.75263 1.29102 8.8803 1.29102 7.99935C1.29102 7.1184 1.46453 6.24607 1.80166 5.43218C2.13878 4.61829 2.63291 3.87877 3.25584 3.25584C3.87877 2.63291 4.61829 2.13878 5.43218 1.80166C6.24607 1.46453 7.1184 1.29102 7.99935 1.29102V14.7077Z"
                                    fill="#C9F7CA"
                                  />
                                  <path
                                    d="M7.99935 14.7077C11.7041 14.7077 14.7077 11.7041 14.7077 7.99935C14.7077 4.2946 11.7041 1.29102 7.99935 1.29102C4.2946 1.29102 1.29102 4.2946 1.29102 7.99935C1.29102 11.7041 4.2946 14.7077 7.99935 14.7077Z"
                                    stroke="#191919"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M11.5 5.08203L7.41667 10.6237L4.5 8.29036"
                                    stroke="#191919"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1907_105392">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>{" "}
                              {isOther === "0" ? (
                                <span>
                                  <b>{selectedCoachName}</b> has accepted your
                                  request.
                                </span>
                              ) : (
                                <span>
                                  <b>{selectedCoachName}</b> has accepted the
                                  request.
                                </span>
                              )}
                            </p>
                          ) : (
                            <p></p>
                          )
                        ) : (
                          <p></p>
                        )}
                        <p className="error-msg">{isCoachError}</p>
                      </div>
                    </>
                  )}
                </div>
                {localStorage.getItem(SessionKeys.SHOW_MENTER_COACH) !== "false" && <div className="col-md-4">
                  {isLoading ? (
                    <div
                      className="input-text position-relative"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"60%"}
                        height={"12px"}
                      />
                      <span
                        className="input__field02"
                        style={{ marginTop: "5px" }}
                      >
                        <ShimmerScreen
                          case={"rect"}
                          width={"100%"}
                          height={"25px"}
                        />
                      </span>
                    </div>
                  ) : (
                    <>
                      <div
                        className={`input-text position-relative ${isEdit ? "input__field_auto_cmplt" : ""
                          }`}
                      >
                        <Autocomplete
                          disabled={isEdit ? false : true}
                          disablePortal
                          size="small"
                          required
                          id="combo-box-demo"
                          autoComplete
                          includeInputInList
                          openOnFocus
                          className={`${mentorInput ? "has-value" : "has-no-value"
                            }`}
                          options={
                            mentorInput !== undefined &&
                              mentorInput?.length >= 2
                              ? users
                              : [
                                {
                                  label:
                                    "Type at least 3 characters to search",
                                  value: "",
                                  showValue:
                                    "Type at least 3 characters to search",
                                },
                              ]
                          }
                          sx={{ width: "100%" }}
                          onChange={(event, value) => {
                            // console.log('value', value)
                            // if (
                            //     value.value === teamLead ||
                            //     value.value === coach ||
                            //     value.value === requestedTeamLeadId ||
                            //     value.value === requestedCoachId
                            // ) {
                            //     setIsMentorError(
                            //         "Please select different user from team lead and coach."
                            //     );
                            //     setMentor("");
                            //     setMentorInput("");
                            // } else {
                            if (_.isEmpty(value)) {
                            } else {
                              setIsMentorError("");
                              setMentor(value.value);
                              setMentorInput(value.showValue);
                            }
                            // }
                          }}
                          onInputChange={(e) => {
                            setCurrentRole(2);
                            if (e !== null) {
                              // console.log('eMentor', e.target.value)
                              setMentorInput(e.target.value);
                              // dispatch(selectedMentor(e.target.value))
                              setMentor(e.target.value);
                              if (e.target.value?.length > 2) {
                                getSearchResult(
                                  e.target.value.trim(),
                                  "mentor"
                                );
                              } else {
                                setUsers([]);
                              }
                            }
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Mentor" />
                          )}
                          value={mentorInput}
                        />
                      </div>

                      <div className="statusshowsec">
                        {!_.isEmpty(selectedMentorStatus) ? (
                          selectedMentorStatus?.toLowerCase() === "reject" ? (
                            <p className=" d-flex align-items-baseline gap-2">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_34_20919)">
                                  <path
                                    d="M7 14C10.8658 14 14 10.8658 14 7C14 3.13417 10.8658 0 7 0C3.13417 0 0 3.13417 0 7C0 10.8658 3.13417 14 7 14Z"
                                    fill="#F57C7C"
                                  />
                                  <path
                                    d="M7 14C6.08075 14 5.1705 13.8189 4.32122 13.4672C3.47194 13.1154 2.70026 12.5998 2.05025 11.9497C1.40024 11.2997 0.884626 10.5281 0.532843 9.67878C0.18106 8.8295 0 7.91925 0 7C0 6.08075 0.18106 5.1705 0.532843 4.32122C0.884626 3.47194 1.40024 2.70026 2.05025 2.05025C2.70026 1.40024 3.47194 0.884626 4.32122 0.532843C5.1705 0.18106 6.08075 -1.36979e-08 7 0V14Z"
                                    fill="#FFCACA"
                                  />
                                  <path
                                    d="M7 0C8.93297 0 10.683 0.783512 11.9498 2.05033C13.2166 3.31702 14.0001 5.06714 14.0001 7C14.0001 8.93309 13.2166 10.683 11.9498 11.9497C10.683 13.2165 8.93297 14 7 14C5.06702 14 3.31702 13.2165 2.05033 11.9497C0.783512 10.683 0 8.93298 0 6.99989C0 5.06702 0.783512 3.31691 2.05033 2.05021C3.31702 0.783512 5.06702 0 7 0ZM9.13281 4.25754C9.28104 4.1092 9.52155 4.1092 9.66978 4.25754C9.818 4.40576 9.818 4.64616 9.66978 4.7945L7.46393 7.00046L9.66978 9.20641C9.818 9.35464 9.818 9.59504 9.66978 9.74338C9.52155 9.8916 9.28104 9.8916 9.13281 9.74338L6.92686 7.53742L4.7209 9.74349C4.57267 9.89172 4.33216 9.89172 4.18394 9.74349C4.03571 9.59515 4.03571 9.35475 4.18394 9.20653L6.39001 7.00057L4.18394 4.7945C4.03571 4.64616 4.03571 4.40576 4.18394 4.25754C4.33216 4.1092 4.57267 4.1092 4.7209 4.25754L6.92697 6.46349L9.13281 4.25754ZM11.4128 2.58717C10.2835 1.45788 8.72334 0.759473 7 0.759473C5.27666 0.759473 3.71659 1.45788 2.58729 2.58717C1.45799 3.71647 0.759473 5.27666 0.759473 6.99989C0.759473 8.72323 1.45799 10.2834 2.58717 11.4127C3.71647 12.5419 5.27655 13.2404 6.99989 13.2404C8.72323 13.2404 10.2834 12.5419 11.4127 11.4127C12.542 10.2834 13.2405 8.72323 13.2405 6.99989C13.2406 5.27666 12.5421 3.71647 11.4128 2.58717Z"
                                    fill="black"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_34_20919">
                                    <rect
                                      width="13.988"
                                      height="14"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>{" "}
                              {isOther === "0" ? (
                                <span>
                                  <b>{selectedMentorName}</b> has rejected your
                                  request.{" "}
                                  {rejectReasonMentor && (
                                    <>
                                      <b> Reason: </b> {rejectReasonMentor}
                                    </>
                                  )}
                                </span>
                              ) : (
                                <span>
                                  <b>{selectedMentorName}</b> has rejected the
                                  request.{" "}
                                  {rejectReasonMentor && (
                                    <>
                                      <b> Reason: </b> {rejectReasonMentor}
                                    </>
                                  )}
                                </span>
                              )}
                            </p>
                          ) : selectedMentorStatus?.toLowerCase() ===
                            "pending" ? (
                            <p className=" d-flex align-items-baseline gap-2">
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1907_105419)">
                                  <path
                                    d="M7 14C10.8658 14 14 10.8658 14 7C14 3.13417 10.8658 0 7 0C3.13417 0 0 3.13417 0 7C0 10.8658 3.13417 14 7 14Z"
                                    fill="#FAA16F"
                                  />
                                  <path
                                    d="M7 14C6.08075 14 5.1705 13.8189 4.32122 13.4672C3.47194 13.1154 2.70026 12.5998 2.05025 11.9497C1.40024 11.2997 0.884626 10.5281 0.532843 9.67878C0.18106 8.8295 0 7.91925 0 7C0 6.08075 0.18106 5.1705 0.532843 4.32122C0.884626 3.47194 1.40024 2.70026 2.05025 2.05025C2.70026 1.40024 3.47194 0.884626 4.32122 0.532843C5.1705 0.18106 6.08075 -1.36979e-08 7 0V14Z"
                                    fill="#FFDDCA"
                                  />
                                  <path
                                    d="M5.92331 4.26033C5.92331 3.9609 6.16591 3.7183 6.46534 3.7183C6.7645 3.7183 7.0071 3.9609 7.0071 4.26033V7.55926L9.26512 8.5518C9.5386 8.67229 9.66291 8.99166 9.54243 9.26514C9.42194 9.53888 9.10257 9.66292 8.82909 9.54244L6.27465 8.41957C6.06947 8.34253 5.92331 8.14446 5.92331 7.91224V4.26033ZM0.253533 4.19449C0.23878 4.14313 0.230857 4.08876 0.230857 4.03276L0.235228 2.02718C0.235228 1.7037 0.49723 1.4417 0.820702 1.4417C1.1439 1.4417 1.40618 1.7037 1.40618 2.02718L1.40454 2.78832C1.75269 2.32524 2.15724 1.90738 2.60881 1.54443C3.06725 1.17642 3.5806 0.860327 4.14367 0.608981C5.90856 -0.178116 7.82371 -0.175931 9.4938 0.46391C11.1513 1.09883 12.569 2.36185 13.3599 4.10434C13.3752 4.13193 13.388 4.16089 13.3984 4.19094C14.1658 5.94354 14.1587 7.84093 13.5241 9.49681C12.914 11.0893 11.7245 12.46 10.0872 13.2665C10.0768 13.2725 10.0664 13.2779 10.0555 13.2834C9.71564 13.4511 9.35993 13.591 8.99711 13.7014C8.8616 13.7413 8.72063 13.7284 8.59605 13.6615C8.18352 13.4394 8.24471 12.8293 8.69249 12.693C8.93236 12.6192 9.16568 12.5326 9.3938 12.4307C9.405 12.425 9.41675 12.4198 9.4285 12.4149C9.48314 12.39 9.53751 12.3643 9.59133 12.3378C9.60581 12.3307 9.62056 12.3242 9.63559 12.3184C11.0185 11.6327 12.0239 10.4713 12.5408 9.12252C13.0853 7.70078 13.0883 6.07249 12.4203 4.57479L12.4201 4.57424C11.7518 3.07655 10.5393 1.99139 9.11923 1.44744C7.69749 0.902674 6.06947 0.899942 4.57177 1.56792C4.10456 1.77586 3.6661 2.04316 3.26723 2.36322C2.88036 2.67404 2.53422 3.03239 2.23698 3.4298L2.70416 3.4033C3.02736 3.38554 3.30411 3.63333 3.32187 3.95681C3.33963 4.28001 3.09184 4.55676 2.76836 4.57452L0.863868 4.68216C0.562799 4.69855 0.302163 4.48518 0.253533 4.19449ZM6.74647 13.9997C7.22594 14.0148 7.47565 13.4383 7.13606 13.0987C7.03852 13.0045 6.92023 12.9526 6.78472 12.9468C6.45906 12.9362 6.14324 12.8998 5.82332 12.8373C5.61787 12.7979 5.41788 12.8766 5.29358 13.0446C5.07092 13.3577 5.23976 13.794 5.61732 13.8702C5.98957 13.9439 6.3672 13.9872 6.74647 13.9997ZM3.49208 13.0648C3.81309 13.2503 4.21716 13.0627 4.27918 12.696C4.31278 12.4783 4.21525 12.2698 4.02619 12.1567C3.74561 11.9931 3.48443 11.8095 3.23417 11.6027C2.85825 11.2928 2.30091 11.6114 2.37741 12.0931C2.39954 12.2215 2.46074 12.3277 2.56018 12.4122C2.85251 12.6547 3.16418 12.873 3.49208 13.0648ZM1.06959 10.7066C1.31219 11.092 1.89384 11.0117 2.02252 10.5743C2.06377 10.4279 2.04328 10.2784 1.96324 10.1489C1.79139 9.87492 1.64359 9.58833 1.51764 9.29027C1.34826 8.88757 0.788191 8.85397 0.573453 9.23454C0.493132 9.37524 0.483296 9.54817 0.546133 9.69734C0.69257 10.0462 0.868512 10.3861 1.06959 10.7066ZM0.0180322 7.49123C0.0349708 7.727 0.204083 7.92043 0.435213 7.96961C0.780541 8.03873 1.09063 7.76853 1.06877 7.41692C1.04555 7.09263 1.04883 6.7738 1.07751 6.44978C1.09363 6.25745 1.00948 6.07659 0.850481 5.96703C0.516627 5.74164 0.0666623 5.95337 0.0286871 6.35416C-0.00559383 6.73227 -0.00915714 7.11254 0.0180322 7.49123Z"
                                    fill="black"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1907_105419">
                                    <rect
                                      width="13.988"
                                      height="14"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              {isOther === "0" ? (
                                <span>
                                  Your request is pending with{" "}
                                  <b>{selectedMentorName}</b>.
                                </span>
                              ) : (
                                <span>
                                  Request is pending with{" "}
                                  <b>{selectedMentorName}</b>.
                                </span>
                              )}
                            </p>
                          ) : selectedMentorStatus?.toLowerCase() ===
                            "accepted" ? (
                            <p className=" d-flex align-items-baseline gap-2">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1907_105392)">
                                  <path
                                    d="M7.99935 14.7077C11.7041 14.7077 14.7077 11.7041 14.7077 7.99935C14.7077 4.2946 11.7041 1.29102 7.99935 1.29102C4.2946 1.29102 1.29102 4.2946 1.29102 7.99935C1.29102 11.7041 4.2946 14.7077 7.99935 14.7077Z"
                                    fill="#78EB7B"
                                  />
                                  <path
                                    d="M7.99935 14.7077C7.1184 14.7077 6.24607 14.5342 5.43218 14.197C4.61829 13.8599 3.87877 13.3658 3.25584 12.7429C2.63291 12.1199 2.13878 11.3804 1.80166 10.5665C1.46453 9.75263 1.29102 8.8803 1.29102 7.99935C1.29102 7.1184 1.46453 6.24607 1.80166 5.43218C2.13878 4.61829 2.63291 3.87877 3.25584 3.25584C3.87877 2.63291 4.61829 2.13878 5.43218 1.80166C6.24607 1.46453 7.1184 1.29102 7.99935 1.29102V14.7077Z"
                                    fill="#C9F7CA"
                                  />
                                  <path
                                    d="M7.99935 14.7077C11.7041 14.7077 14.7077 11.7041 14.7077 7.99935C14.7077 4.2946 11.7041 1.29102 7.99935 1.29102C4.2946 1.29102 1.29102 4.2946 1.29102 7.99935C1.29102 11.7041 4.2946 14.7077 7.99935 14.7077Z"
                                    stroke="#191919"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M11.5 5.08203L7.41667 10.6237L4.5 8.29036"
                                    stroke="#191919"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1907_105392">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>{" "}
                              {isOther === "0" ? (
                                <span>
                                  <b>{selectedMentorName}</b> has accepted your
                                  request.
                                </span>
                              ) : (
                                <span>
                                  <b>{selectedMentorName}</b> has accepted the
                                  request.
                                </span>
                              )}
                            </p>
                          ) : (
                            <p></p>
                          )
                        ) : (
                          <p></p>
                        )}
                      </div>
                      <p className="error-msg">{isMentorError}</p>
                    </>
                  )}
                </div>}
                {localStorage.getItem(SessionKeys.SHOW_MENTER_COACH) !== "false" && <div className="col-md-4">
                  {isLoading ? (
                    <div
                      className="input-text position-relative"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"60%"}
                        height={"12px"}
                      />
                      <span
                        className="input__field02"
                        style={{ marginTop: "5px" }}
                      >
                        <ShimmerScreen
                          case={"rect"}
                          width={"100%"}
                          height={"25px"}
                        />
                      </span>
                    </div>
                  ) : (
                    <>
                      <div
                        className={`input-text position-relative ${isEdit ? "input__field_auto_cmplt" : ""
                          }`}
                      >
                        <Autocomplete
                          disablePortal
                          disabled={isEdit ? false : true}
                          size="small"
                          id="combo-box-demo"
                          autoComplete
                          includeInputInList
                          className={`${teamLeadInput ? "has-value" : "has-no-value"
                            }`}
                          // renderOption={option=> {console.log('option',option)}}
                          options={
                            teamLeadInput !== undefined &&
                              teamLeadInput?.length >= 2
                              ? users
                              : [
                                {
                                  label:
                                    "Type at least 3 characters to search",
                                  value: "",
                                  showValue:
                                    "Type at least 3 characters to search",
                                },
                              ]
                          }
                          sx={{ width: "100%" }}
                          onChange={(event, value) => {
                            // console.log("selectedValue ", value)
                            // if (
                            //     value.value === mentor ||
                            //     // value.value === coach ||
                            //     value.value === requestedMentorId
                            //     //|| value.value === requestedCoachId
                            // ) {
                            //     setIsTeamLeadError(
                            //         "Please select different user for team lead and mentor."
                            //     );
                            //     setTeamLead("");
                            //     setTeamLeadInput("");
                            // } else {
                            if (!_.isEmpty(value)) {
                              setIsTeamLeadError("");
                              setTeamLead(value.value);
                              setTeamLeadInput(value.showValue);
                            }
                          }}
                          onInputChange={(e) => {
                            setCurrentRole(3);
                            if (e !== null) {
                              setTeamLeadInput(e.target.value);
                              setTeamLead(e.target.value);
                              // dispatch(selectedTeamLead(e.target.value))
                              if (e.target.value?.length > 2) {
                                getSearchResult(
                                  e.target.value.trim(),
                                  "team_lead"
                                );
                              } else {
                                setUsers([]);
                              }
                            }
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Team Lead" />
                          )}
                          value={teamLeadInput}
                        />
                      </div>

                      <div className="statusshowsec">
                        {!_.isEmpty(selectedTeamLeadStatus) ? (
                          selectedTeamLeadStatus?.toLowerCase() === "reject" ? (
                            <p className=" d-flex align-items-baseline gap-2">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_34_20919)">
                                  <path
                                    d="M7 14C10.8658 14 14 10.8658 14 7C14 3.13417 10.8658 0 7 0C3.13417 0 0 3.13417 0 7C0 10.8658 3.13417 14 7 14Z"
                                    fill="#F57C7C"
                                  />
                                  <path
                                    d="M7 14C6.08075 14 5.1705 13.8189 4.32122 13.4672C3.47194 13.1154 2.70026 12.5998 2.05025 11.9497C1.40024 11.2997 0.884626 10.5281 0.532843 9.67878C0.18106 8.8295 0 7.91925 0 7C0 6.08075 0.18106 5.1705 0.532843 4.32122C0.884626 3.47194 1.40024 2.70026 2.05025 2.05025C2.70026 1.40024 3.47194 0.884626 4.32122 0.532843C5.1705 0.18106 6.08075 -1.36979e-08 7 0V14Z"
                                    fill="#FFCACA"
                                  />
                                  <path
                                    d="M7 0C8.93297 0 10.683 0.783512 11.9498 2.05033C13.2166 3.31702 14.0001 5.06714 14.0001 7C14.0001 8.93309 13.2166 10.683 11.9498 11.9497C10.683 13.2165 8.93297 14 7 14C5.06702 14 3.31702 13.2165 2.05033 11.9497C0.783512 10.683 0 8.93298 0 6.99989C0 5.06702 0.783512 3.31691 2.05033 2.05021C3.31702 0.783512 5.06702 0 7 0ZM9.13281 4.25754C9.28104 4.1092 9.52155 4.1092 9.66978 4.25754C9.818 4.40576 9.818 4.64616 9.66978 4.7945L7.46393 7.00046L9.66978 9.20641C9.818 9.35464 9.818 9.59504 9.66978 9.74338C9.52155 9.8916 9.28104 9.8916 9.13281 9.74338L6.92686 7.53742L4.7209 9.74349C4.57267 9.89172 4.33216 9.89172 4.18394 9.74349C4.03571 9.59515 4.03571 9.35475 4.18394 9.20653L6.39001 7.00057L4.18394 4.7945C4.03571 4.64616 4.03571 4.40576 4.18394 4.25754C4.33216 4.1092 4.57267 4.1092 4.7209 4.25754L6.92697 6.46349L9.13281 4.25754ZM11.4128 2.58717C10.2835 1.45788 8.72334 0.759473 7 0.759473C5.27666 0.759473 3.71659 1.45788 2.58729 2.58717C1.45799 3.71647 0.759473 5.27666 0.759473 6.99989C0.759473 8.72323 1.45799 10.2834 2.58717 11.4127C3.71647 12.5419 5.27655 13.2404 6.99989 13.2404C8.72323 13.2404 10.2834 12.5419 11.4127 11.4127C12.542 10.2834 13.2405 8.72323 13.2405 6.99989C13.2406 5.27666 12.5421 3.71647 11.4128 2.58717Z"
                                    fill="black"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_34_20919">
                                    <rect
                                      width="13.988"
                                      height="14"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>{" "}
                              {isOther === "0" ? (
                                <span>
                                  <b>{selectedTeamLeadName}</b> has rejected
                                  your request.{" "}
                                  {rejectReasonTeamLead && (
                                    <>
                                      <b> Reason: </b> {rejectReasonTeamLead}
                                    </>
                                  )}
                                </span>
                              ) : (
                                <span>
                                  <b>{selectedTeamLeadName}</b> has rejected the
                                  request.{" "}
                                  {rejectReasonTeamLead && (
                                    <>
                                      <b> Reason: </b> {rejectReasonTeamLead}
                                    </>
                                  )}
                                </span>
                              )}
                            </p>
                          ) : selectedTeamLeadStatus?.toLowerCase() ===
                            "pending" ? (
                            <p className=" d-flex align-items-baseline gap-2">
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1907_105419)">
                                  <path
                                    d="M7 14C10.8658 14 14 10.8658 14 7C14 3.13417 10.8658 0 7 0C3.13417 0 0 3.13417 0 7C0 10.8658 3.13417 14 7 14Z"
                                    fill="#FAA16F"
                                  />
                                  <path
                                    d="M7 14C6.08075 14 5.1705 13.8189 4.32122 13.4672C3.47194 13.1154 2.70026 12.5998 2.05025 11.9497C1.40024 11.2997 0.884626 10.5281 0.532843 9.67878C0.18106 8.8295 0 7.91925 0 7C0 6.08075 0.18106 5.1705 0.532843 4.32122C0.884626 3.47194 1.40024 2.70026 2.05025 2.05025C2.70026 1.40024 3.47194 0.884626 4.32122 0.532843C5.1705 0.18106 6.08075 -1.36979e-08 7 0V14Z"
                                    fill="#FFDDCA"
                                  />
                                  <path
                                    d="M5.92331 4.26033C5.92331 3.9609 6.16591 3.7183 6.46534 3.7183C6.7645 3.7183 7.0071 3.9609 7.0071 4.26033V7.55926L9.26512 8.5518C9.5386 8.67229 9.66291 8.99166 9.54243 9.26514C9.42194 9.53888 9.10257 9.66292 8.82909 9.54244L6.27465 8.41957C6.06947 8.34253 5.92331 8.14446 5.92331 7.91224V4.26033ZM0.253533 4.19449C0.23878 4.14313 0.230857 4.08876 0.230857 4.03276L0.235228 2.02718C0.235228 1.7037 0.49723 1.4417 0.820702 1.4417C1.1439 1.4417 1.40618 1.7037 1.40618 2.02718L1.40454 2.78832C1.75269 2.32524 2.15724 1.90738 2.60881 1.54443C3.06725 1.17642 3.5806 0.860327 4.14367 0.608981C5.90856 -0.178116 7.82371 -0.175931 9.4938 0.46391C11.1513 1.09883 12.569 2.36185 13.3599 4.10434C13.3752 4.13193 13.388 4.16089 13.3984 4.19094C14.1658 5.94354 14.1587 7.84093 13.5241 9.49681C12.914 11.0893 11.7245 12.46 10.0872 13.2665C10.0768 13.2725 10.0664 13.2779 10.0555 13.2834C9.71564 13.4511 9.35993 13.591 8.99711 13.7014C8.8616 13.7413 8.72063 13.7284 8.59605 13.6615C8.18352 13.4394 8.24471 12.8293 8.69249 12.693C8.93236 12.6192 9.16568 12.5326 9.3938 12.4307C9.405 12.425 9.41675 12.4198 9.4285 12.4149C9.48314 12.39 9.53751 12.3643 9.59133 12.3378C9.60581 12.3307 9.62056 12.3242 9.63559 12.3184C11.0185 11.6327 12.0239 10.4713 12.5408 9.12252C13.0853 7.70078 13.0883 6.07249 12.4203 4.57479L12.4201 4.57424C11.7518 3.07655 10.5393 1.99139 9.11923 1.44744C7.69749 0.902674 6.06947 0.899942 4.57177 1.56792C4.10456 1.77586 3.6661 2.04316 3.26723 2.36322C2.88036 2.67404 2.53422 3.03239 2.23698 3.4298L2.70416 3.4033C3.02736 3.38554 3.30411 3.63333 3.32187 3.95681C3.33963 4.28001 3.09184 4.55676 2.76836 4.57452L0.863868 4.68216C0.562799 4.69855 0.302163 4.48518 0.253533 4.19449ZM6.74647 13.9997C7.22594 14.0148 7.47565 13.4383 7.13606 13.0987C7.03852 13.0045 6.92023 12.9526 6.78472 12.9468C6.45906 12.9362 6.14324 12.8998 5.82332 12.8373C5.61787 12.7979 5.41788 12.8766 5.29358 13.0446C5.07092 13.3577 5.23976 13.794 5.61732 13.8702C5.98957 13.9439 6.3672 13.9872 6.74647 13.9997ZM3.49208 13.0648C3.81309 13.2503 4.21716 13.0627 4.27918 12.696C4.31278 12.4783 4.21525 12.2698 4.02619 12.1567C3.74561 11.9931 3.48443 11.8095 3.23417 11.6027C2.85825 11.2928 2.30091 11.6114 2.37741 12.0931C2.39954 12.2215 2.46074 12.3277 2.56018 12.4122C2.85251 12.6547 3.16418 12.873 3.49208 13.0648ZM1.06959 10.7066C1.31219 11.092 1.89384 11.0117 2.02252 10.5743C2.06377 10.4279 2.04328 10.2784 1.96324 10.1489C1.79139 9.87492 1.64359 9.58833 1.51764 9.29027C1.34826 8.88757 0.788191 8.85397 0.573453 9.23454C0.493132 9.37524 0.483296 9.54817 0.546133 9.69734C0.69257 10.0462 0.868512 10.3861 1.06959 10.7066ZM0.0180322 7.49123C0.0349708 7.727 0.204083 7.92043 0.435213 7.96961C0.780541 8.03873 1.09063 7.76853 1.06877 7.41692C1.04555 7.09263 1.04883 6.7738 1.07751 6.44978C1.09363 6.25745 1.00948 6.07659 0.850481 5.96703C0.516627 5.74164 0.0666623 5.95337 0.0286871 6.35416C-0.00559383 6.73227 -0.00915714 7.11254 0.0180322 7.49123Z"
                                    fill="black"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1907_105419">
                                    <rect
                                      width="13.988"
                                      height="14"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>

                              {isOther === "0" ? (
                                <span>
                                  Your request is pending with{" "}
                                  <b>{selectedTeamLeadName}</b>.
                                </span>
                              ) : (
                                <span>
                                  Request is pending with{" "}
                                  <b>{selectedTeamLeadName}</b>.
                                </span>
                              )}
                            </p>
                          ) : selectedTeamLeadStatus?.toLowerCase() ===
                            "accepted" ? (
                            <p className=" d-flex align-items-baseline gap-2">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1907_105392)">
                                  <path
                                    d="M7.99935 14.7077C11.7041 14.7077 14.7077 11.7041 14.7077 7.99935C14.7077 4.2946 11.7041 1.29102 7.99935 1.29102C4.2946 1.29102 1.29102 4.2946 1.29102 7.99935C1.29102 11.7041 4.2946 14.7077 7.99935 14.7077Z"
                                    fill="#78EB7B"
                                  />
                                  <path
                                    d="M7.99935 14.7077C7.1184 14.7077 6.24607 14.5342 5.43218 14.197C4.61829 13.8599 3.87877 13.3658 3.25584 12.7429C2.63291 12.1199 2.13878 11.3804 1.80166 10.5665C1.46453 9.75263 1.29102 8.8803 1.29102 7.99935C1.29102 7.1184 1.46453 6.24607 1.80166 5.43218C2.13878 4.61829 2.63291 3.87877 3.25584 3.25584C3.87877 2.63291 4.61829 2.13878 5.43218 1.80166C6.24607 1.46453 7.1184 1.29102 7.99935 1.29102V14.7077Z"
                                    fill="#C9F7CA"
                                  />
                                  <path
                                    d="M7.99935 14.7077C11.7041 14.7077 14.7077 11.7041 14.7077 7.99935C14.7077 4.2946 11.7041 1.29102 7.99935 1.29102C4.2946 1.29102 1.29102 4.2946 1.29102 7.99935C1.29102 11.7041 4.2946 14.7077 7.99935 14.7077Z"
                                    stroke="#191919"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M11.5 5.08203L7.41667 10.6237L4.5 8.29036"
                                    stroke="#191919"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1907_105392">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>{" "}
                              {isOther === "0" ? (
                                <span>
                                  <b>{selectedTeamLeadName}</b> has accepted
                                  your request.
                                </span>
                              ) : (
                                <span>
                                  <b>{selectedTeamLeadName}</b> has accepted the
                                  request.
                                </span>
                              )}
                            </p>
                          ) : (
                            <p></p>
                          )
                        ) : (
                          <p></p>
                        )}
                      </div>
                      <p className="error-msg">{isTeamLeadError}</p>
                    </>
                  )}
                </div>}
              </div>

              <div className="row mt-1 edit_profile_input nffgh">
                {isLoading ? (
                  <label className="infoedit">
                    <ShimmerScreen
                      case={"rect"}
                      width={"50%"}
                      height={"2rem"}
                    />
                  </label>
                ) : (
                  <label className="infoedit">
                    <i>
                      For more information around these roles, please do contact
                      your Manager.
                    </i>
                  </label>
                )}
              </div>
            </>
          ) : (
            ""
          )}

          {isOther === "1" ? (
            ""
          ) : (
            <div className="row mt-3">
              <div className={`col-md-12 mb-3 ${!isEdit ? "mt-3s" : ""}`}>
                <div
                  className={`edit_btn ${isEdit ? "d-flex justify-content-end gap-4" : ""
                    }`}
                >
                  {isLoading ? (
                    <ShimmerScreen
                      case={"rect"}
                      height={"40px"}
                      width={"20%"}
                    />
                  ) : (
                    <button
                      className="btn-primary"
                      onClick={() => {
                        setIsCoachError("");
                        setIsMentorError("");
                        setIsTeamLeadError("");
                        setIsTimezoneError("");
                        if (isEdit) {
                          clickStreamUser("save_profile_btn_click", {
                            user_id: authBroker.payload.user.user_id,
                          });
                          userProfileUpdate();
                        } else {
                          clickStreamUser("edit_profile_btn_click", {
                            user_id: authBroker.payload.user.user_id,
                          });
                          setIsEdit(true);
                        }
                      }}
                    >
                      {isEdit ? "Save" : "Edit Profile"}
                    </button>
                  )}
                  {isLoading && isEdit ? (
                    <ShimmerScreen
                      case={"rect"}
                      height={"40px"}
                      width={"20%"}
                    />
                  ) : isEdit ? (
                    <button
                      className="btn-primary"
                      onClick={() => {
                        clickStreamUser("cancel_edit_profile_btn_click", {
                          user_id: authBroker.payload.user.user_id,
                        });
                        setIsEdit(false);
                      }}
                    >
                      Cancel
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          )}

          <ConfirmModal
            confirmModal={confirmModal}
            setConfirmModal={setConfirmModal}
            showModalMsg={showModalMsg}
            isConfirm={isConfirm}
            isRightIcon={true}
          />
        </div>
      </section>
    </>
  );
};
export default ProfilEdit;
